<template>
  <v-radio-group
    :class="customData.class"
    v-bind="customData.props"
    v-on="customData.on"
  >
    <slot />
  </v-radio-group>
</template>

<script>
// components
import { VRadioGroup } from 'vuetify/lib';

// mixins
import isRequired from '@/mixins/component/is-required-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';

// helpers
import { filterProps } from '@/utils/functional-component-utils';
import { getRequiredLabelProp } from '@/components/global_components/forms/utils/required-label-util';

export default {
  name: "WorkRadioGroup",
  mixins: [isRequired, pendingAble],
  props: {
    ...VRadioGroup.options.props,
  },
  computed: {
    customData() {
      return {
        props: {
          ...filterProps(this.$props, 'label'),
          ...this.$attrs,
          ...getRequiredLabelProp(this.$props),
        },
        on: {
          ...this.$listeners,
          change: (value) => this.$emit('input', value),
        },
        class: ['w-radio-group--input']
      };
    }
  }
};
</script>